import styled from '@emotion/styled';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';
import { withConfig } from 'src/withConfig';

export const MiniGameWrapper = withConfig(theme => styled('div', { label: 'MiniGameWrapper' })`
    aspect-ratio: 4/3;
    border-radius: ${theme.star.casino.casinoMini.radius};
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%;
    &:hover > div {
        visibility: visible;
    }
`);

export const MiniGameImgWrapperLazy = styled(LazyImage, { label: 'MiniGameImgWrapperLazy' })`
    inset: 0;
`;
